const Request = require('@/repositories/request')
const qs = require('qs')

class Specialty extends Request {
  /**
   *
   * @param {int} id
   * @returns {*}
   */
  findOne(id) {
    return this.$strapi.$specialties.findOne(id)
  }

  /**
   *
   * @param {Object} params
   * @return {*}
   */
  findAll(params) {
    const stringifyParams = qs.stringify({ ...params }, { encode: false })
    return this.$strapi.$specialties.find(stringifyParams)
  }
}

module.exports = Specialty
